
<product-category-products v-if="categoryAssignment.ui_template === CATEGORY_ASSIGNMENT_UI_TEMPLATES.NON_BTO_CLASSIC.value"
                           :show-inventory="false"
                           :template-id="categoryAssignment.cfg_template_id"
                           summary-price-name="esup"
                           :dialog-prices-list="[{key:'esup',label:'MSRP'}]"
                           :dialog-attributes-list="[]"
                           :is-public="isPublic" >
</product-category-products>
<product-category-products v-else-if="categoryAssignment.ui_template === CATEGORY_ASSIGNMENT_UI_TEMPLATES.NON_BTO_CLASSIC_WITH_STOCK.value"
                           :show-inventory="true"
                           :template-id="categoryAssignment.cfg_template_id"
                           summary-price-name="esup"
                           :dialog-prices-list="[{key:'esup',label:'MSRP'}]"
                           :dialog-attributes-list="[{key: 'product_inventory', label: 'Quantity Available'}]"
                           :is-public="isPublic" >
</product-category-products>
<product-category-assignment-non-bto-cards v-else-if="categoryAssignment.ui_template === CATEGORY_ASSIGNMENT_UI_TEMPLATES.NON_BTO_CARDS.value"
                                           :template-id="categoryAssignment.cfg_template_id"
                                           :is-public="isPublic"></product-category-assignment-non-bto-cards>
<div v-else>This should not display</div>

